import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetCustomerLanguages } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCustomerLanguages } from 'backend/customers';
import { useTranslation } from 'react-i18next';
import style from './DefaultLanguageSelect.module.scss';

interface IDefaultLanguageSelect {
	setIDDefaultLanguage: (value: Nullable<string>) => void;
	setFetchedLanguages: (value: IItemForGetShortInfo[]) => void;
	IDSelectedCustomer: Nullable<string>;
}

const DefaultLanguageSelect: React.FC<IDefaultLanguageSelect> = ({
	IDSelectedCustomer,
	setIDDefaultLanguage,
	setFetchedLanguages,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCustomerLanguages, string>(
		IDSelectedCustomer ? getCustomerLanguages : null,
		IDSelectedCustomer || '',
	);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectDefaultLanguage') }], [t]);

	useEffect(() => {
		refetch();
	}, [IDSelectedCustomer]);

	useEffect(() => {
		response && setFetchedLanguages(response.data.languages);
	}, [response]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.languages.map((el) => ({
				id: el.id,
				name: tForm(el.name),
			})) || []
		);
	}, [tForm, response]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="DefaultLanguageSelect"
			name="IDDefaultLanguage"
			label="defaultLanguageLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDDefaultLanguage}
			disabled={!IDSelectedCustomer}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DefaultLanguageSelect);
